/** Local copy of the events list `window` blob from GET /api/planner/events/ — used offline + first paint. */

export const STORAGE_KEY_PLANNER_EVENTS_LIST_WINDOW = 'qapp.planner.eventsListWindow';

export function readPlannerEventsListWindowFromStorage() {
  if (typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PLANNER_EVENTS_LIST_WINDOW);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (o && typeof o.year_from === 'number' && typeof o.year_to === 'number') return o;
    return null;
  } catch {
    return null;
  }
}

export function writePlannerEventsListWindowToStorage(meta) {
  if (typeof localStorage === 'undefined' || !meta) return;
  try {
    localStorage.setItem(STORAGE_KEY_PLANNER_EVENTS_LIST_WINDOW, JSON.stringify(meta));
  } catch {
    // ignore quota / private mode
  }
}

/**
 * Unpack list response: { results, window } after API change; tolerant of legacy array / { results } only.
 */
export function parsePlannerEventsListResponse(body) {
  if (!body || typeof body !== 'object') {
    return { records: [] };
  }
  const records = Array.isArray(body.results) ? body.results : Array.isArray(body) ? body : [];
  if (!('window' in body)) {
    return { records };
  }
  return { records, meta: body.window };
}
